import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import {
  makeGetStockDetail,
  makeGetStockTrade,
} from '../../../../lib/selector';

import { filter, isEqual, map, sumBy } from 'lodash';
import PerfectScrollBar from 'react-perfect-scrollbar';

import * as echarts from 'echarts';

// Hook
function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = useRef();

  // Store current value in ref
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return ref.current;
}

function arrSorter(params) {
  let bg = Array.from(new Set(params));
  bg.sort(function (a, b) {
    return b - a;
  });

  return bg;
}

function arrSumBy(par1, par2) {
  let _rsData = [];
  par1.forEach((element) => {
    let arrByPrice = filter(par2, (o) => o.lastPrice === element);
    const _sum = sumBy(arrByPrice, 'lastVol');
    _rsData.push(_sum);
  });

  return _rsData;
}

function TabECharts(props) {
  const chartComponent = React.useRef(null);
  const [chartOptions, setChartOptions] = useState();

  const { collectionPrice } = props;

  const preStockTrade = usePrevious(collectionPrice);

  useEffect(() => {
    if (
      collectionPrice &&
      !!collectionPrice.length &&
      !isEqual(collectionPrice, preStockTrade)
    ) {
      // console.log('re render')
      _handleProcessPrice();
    }
  }, [collectionPrice]);

  const _handleProcessPrice = () => {
    // const { stockTrade, stockDetail } = props;
    // const dupeArray = map(stockTrade, 'lastPrice');
    // // console.log(stockDetail)
    // // const _totalVol = sumBy(stockTrade, 'lastVol')

    // const bg = arrSorter(dupeArray);

    // const _rsData = arrSumBy(bg, stockTrade)
    // // console.log(_rsData, chartOptions);

    if (!collectionPrice || !collectionPrice.length) {
      return;
    }

    // let _chartOptions = Object.assign({}, chartOptions)

    // _chartOptions.xAxis.categories = bg;
    // _chartOptions.series = [
    //   {
    //     name: stockDetail.sym,
    //     data: _rsData,
    //   },
    // ]

    var option = {
      xAxis: {
        max: 'dataMax',
      },
      yAxis: {
        type: 'category',
        data: map(collectionPrice, 'last_price'),
        // inverse: true,
        // animationDuration: 300,
        // animationDurationUpdate: 300,
      },
      grid: [
        {
          left: 50,
          right: 50,
          top: 20,
          bottom: 30,
        },
      ],
      series: [
        {
          // realtimeSort: true,
          type: 'bar',
          data: map(collectionPrice, 'vol'),
          label: {
            show: true,
            position: 'right',
            valueAnimation: true,
          },
        },
      ],
      legend: {
        show: false,
      },
      animationDuration: 0,
      animationDurationUpdate: 3000,
      animationEasing: 'linear',
      animationEasingUpdate: 'linear',
    };

    var chartDom = document.getElementById('main-echarts');
    var myChart = echarts.init(chartDom);
    setTimeout(() => {
      console.log(option);
      option && myChart.setOption(option);
    }, 200);
  };

  return (
    <PerfectScrollBar style={{ height: 'calc( 100vh - 390px )' }}>
      <div id="main-echarts" style={{ height: '100%', width: '100%' }}></div>
    </PerfectScrollBar>
  );
}

const makeMapStateToProps = () => {
  const getStockTrade = makeGetStockTrade();
  const getStockDetail = makeGetStockDetail();

  const mapStateToProps = (state) => {
    return {
      stockDetail: getStockDetail(state),
      stockTrade: getStockTrade(state),
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(TabECharts);
